<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-curtain`]" width="1em" height="1em" v-bind="$attrs"><path d="M16 11h2a1 1 0 011 1v28a1 1 0 01-1 1h-2a1 1 0 01-1-1V12a1 1 0 011-1zm14 0h2a1 1 0 011 1v28a1 1 0 01-1 1h-2a1 1 0 01-1-1V12a1 1 0 011-1zm13-1a2 2 0 012 2v30.365a2 2 0 01-2.492 1.938C39.086 43.434 35.916 43 33 43c-3.613 0-6.613.666-9 2-2.431-1.334-5.431-2-9-2-2.887 0-6.057.436-9.51 1.31A2 2 0 013 42.37V12a2 2 0 012-2h38zm0-7a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V4a1 1 0 011-1h38zM7 14v25.862C9.823 39.29 12.49 39 15 39c3.352 0 6.356.516 8.99 1.578C26.604 39.515 29.615 39 33 39c2.528 0 5.195.287 8 .856V14H7z"/></svg>
</template>
<script>

export default {
  name: 'IconCurtain',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
